// Importaciones
import Auth from "./middleware/Auth";
import store from "@/store";

// Constantes
const permissions = store.state.auth?.permissions || {};

// Funciones
const hasAnyPermission = (keys = []) => {
  return keys.some((key) => {
    const [group, action] = key.split(".");
    return permissions?.[group]?.[action] == 1;
  });
};

const hasPermissionGroup = (groupKeys) => hasAnyPermission(groupKeys);

// Datos
export const getSideBarItems = () => {
  const links = [
    {
      title: "Inicio",
      link: "home",
      icon: "mdi-home",
      show: Auth(),
    },
    {
      title: "Buscador",
      link: "finder",
      icon: "mdi-magnify",
      show: hasPermissionGroup([
        "net_finder_doctor.read",
        "net_finder_provider.read",
        "net_finder_provider_bills.read",
        "net_finder_fiscal_folio.read",
      ]),
    },
    {
      title: "Facturación",
      link: "bills",
      icon: "mdi-file",
      show: hasPermissionGroup([
        "net_bills_ipa.read",
        "net_bills_pharmacy_multi_documentations.read",
        "net_bills_multipayments.read",
        "net_bills_rha_report.read",
        "net_bills_rha_provider_duplicate_report.read",
        "net_bills_rha_pending_payment_report.read",
        "net_bills_rha_facturapi_cancel_review.read",
        "net_bills_rs_report",
      ]),
    },
    {
      title: "Servicios",
      link: "rs_services",
      icon: "mdi-file-document",
      show: hasPermissionGroup([
        "net_rs_services_cppd.read",
        "net_rs_services_cppd_payments.read",
        "net_rs_services_telemedicine.read",
      ]),
    },
    {
      title: "Ingresos",
      link: "rhas",
      icon: "mdi-file-document",
      show: hasPermissionGroup(["net_rhas_rbdc.read"]),
    },
    {
      title: "Asegurados",
      link: "insureds",
      icon: "mdi-account-injury",
      show: hasPermissionGroup([
        "net_insureds_txt_accounts.read",
        "net_insureds_self_insurance_excess_report.read",
      ]),
    },
    {
      title: "Proveedores",
      link: "providers",
      icon: "mdi-hospital-building",
      show: hasPermissionGroup(["net_providers_txt_accounts.read"]),
    },
    {
      title: "Médicos",
      link: "doctors",
      icon: "mdi-doctor",
      show: hasPermissionGroup(["net_doctors_prb.read"]),
    },
    {
      title: "Admin. Nómina",
      link: "employee_payroll_reviews",
      icon: "mdi-account-cash",
      show: hasPermissionGroup(["net_employee_payroll_reviews.read"]),
    },
    {
      title: "Sgto. de renovación de contratos",
      link: "employee_contract_renewals",
      icon: "mdi-file-refresh-outline",
      show: hasPermissionGroup(["net_employee_contract_renewals.read"]),
    },
    {
      title: "Empleados",
      link: "employees",
      icon: "mdi-account",
      show: hasPermissionGroup([
        "net_employees.read",
        "net_employees_offices.read",
        "net_employees_positions.read",
      ]),
    },
    {
      title: "Proveedores admin.",
      link: "vendors",
      icon: "mdi-account-group",
      show: hasPermissionGroup(["net_vendors.read"]),
    },
    {
      title: "Pagos",
      link: "payments",
      icon: "mdi-cash",
      show: hasPermissionGroup(["net_payments.read"]),
    },
  ];

  return [
    {
      links: links.filter((item) => item.show),
    },
    { divider: true },
  ];
};
